var map = {
	"./arcade.png": "881c",
	"./fish.png": "704e",
	"./hot.png": "4c58",
	"./live.png": "00c6",
	"./poker.png": "039e",
	"./slot.png": "d204",
	"./sports.png": "9e9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ce7";